<template>
  <div>
  <v-container >
    <h2 class="mb-4  cardTitle">{{$store.state.bookingSteps.stepsData.step1.title}}</h2>
    <v-row v-if="loading">
      <v-col
          v-for="index in 16"
          :key="index"
          :cols="4"
          md="3"
          lg="2" 
          class="custom8cols">
        <v-skeleton-loader
            v-if="loading"
            :height="100"
            type="image"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-item-group v-model="selected" class="stepper-padding" v-else @change="nextStep">
      <v-row align="center">
        <v-col
          v-for="spe in specialities"
          :key="spe.id"
          :cols="4"
          md="3"
          lg="2" 
          style="padding: 0 !important;"
        >
          <v-item v-slot="{ active, toggle }">
            <v-card
                class="d-flex align-center"
                elevation="0"
            >
              <v-scroll-y-transition>
                <div class="text-center  speciality-card" @click="toggle">
                  <div class="image">
                    <img  :src="spe.image_url" alt="">
                    <span class="count" v-if="spe.count"> {{spe.count}} </span>
                  </div>
                  <h5 class="title">{{spe.name}}</h5>
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-col>
      </v-row>
    </v-item-group>

  </v-container>

    <div class="step-nav">
      <div class="d-flex align-center justify-center w-full">
        <v-btn outlined  color="secondary" class="mx-5"  @click="$emit('cancel')">
          {{$store.state.bookingSteps.stepsData.cancelButtonLabel}}
        </v-btn>

        <v-btn  color="primary" class="mx-5"  :disabled="selected === null" @click="nextStep" elevation="0">
          {{$store.state.bookingSteps.stepsData.nextButtonLabel}}
        </v-btn>
      </div>
    </div>
  </div>

</template>

<script>
import API from "../../../../utils/dynamicAPI";

export default {
  name: "step1",
  data () {
    return {
      selected: null,
      specialities: [],
      loading: false
    }
  },
  async mounted() {
    this.loading = true

    if (this.$store.state.bookingSteps.stepsData.step1.request.type === 'get') {
      let res = await API.getAPI(this.$store.state.bookingSteps.stepsData.step1.request , this.$store.state.bookingSteps.stepsData.step1.request.headers)
      this.specialities = res.data.data
    }
    else if (this.$store.state.bookingSteps.stepsData.step1.request.type === 'post') {
      let res = await API.postAPI(this.$store.state.bookingSteps.stepsData.step1.request , this.$store.state.bookingSteps.stepsData.step1.request.headers)
      this.specialities = res.data.data
    }
    this.loading = false
  },
  methods: {
    nextStep () {
      this.$store.state.bookingSteps.selectedStepsData[this.$store.state.bookingSteps.stepsData.step1.selectedNameAttribute] = this.specialities[this.selected].name
      this.$store.state.bookingSteps.selectedStepsData[this.$store.state.bookingSteps.stepsData.step1.selectedIdAttribute] = this.specialities[this.selected].id
      this.$emit('nextStep')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 12px;
  box-shadow: none !important;
  box-sizing: border-box;
  height: 180px;
  overflow: hidden;
  padding: 10px;
}

.speciality-card {
  align-items: center;
  border: 1px solid #F2F3F4 !important;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;

  .image {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 56px;
    justify-content: center;
    position: relative;
    width: 56px;

    img {
      background: transparent;
      border: none;
      border-radius: 0;
      height: 56px;
      width: 56px;
    }

    .count {
      align-items: center;
      background: #E5E6ED;
      border-radius: 50%;
      color: var(--secondaryColor);
      display: flex;
      font-family: Roboto;
      font-size: 10px;
      height: 16px;
      justify-content: center;
      position: absolute;
      right: -2px;
      top: -2px;
      width: 16px;
    }
  }

  .title {
    font-weight: 500;
    text-transform: uppercase;
  }
}

.v-item--active .speciality-card {
  background: var(--secondaryColor);

  .image {
    border-color: white;

    img {
      filter: brightness(0) invert(1) !important;
    }
  }

 .title {
    color: white;
  }
}
</style>

<style lang="scss">
@media (min-width: 1300px) {
  .custom8cols {
    flex-basis: 12.5%;
    max-width: 12.5%;
    width: 12.5%;
  }
}
</style>
